var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"container-fluid p-0 mb-12"},[_c('b-overlay',{attrs:{"show":_vm.$store.state.app.showLoader,"rounded":"sm"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }